import { useMemo } from "react";

import useApi from "hooks/api";

import { buildLeaveTypesRepository } from "../infrastructure";
import { buildPolicyRepository } from "shared/infrastructure";
import { createUseLeaveTypes } from "./useLeaveTypes";

export const useLeaveTypes = ({ colaboraInstanceId }: { colaboraInstanceId: string | undefined }) => {
  const { genericApiCall } = useApi();

  const leaveTypesRepository = useMemo(
    () => buildLeaveTypesRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const policyRepository = useMemo(
    () => buildPolicyRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const useLeaveTypesQuery = useMemo(
    () => createUseLeaveTypes({ leaveTypesRepository, policyRepository }),
    [leaveTypesRepository, policyRepository],
  );

  return useLeaveTypesQuery({ colaboraInstanceId });
};
